// External
import React from 'react';

// Internal
import Upgrade from 'features/upgrade/containers/Upgrade';

export default () => <Upgrade />;
